import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

import { ref, PropType, watch, onUnmounted } from 'vue'
import Sortable, { SortableOptions, SortableEvent } from 'sortablejs'
import type { AutoScrollOptions } from 'sortablejs/plugins'

type SortableOptionsProp = SortableOptions | AutoScrollOptions
type ElementType = {
  index: number,
  itemHeight: number,
  itemRectY:number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Sortable',
  props: {
  options: {
    type: Object as PropType<SortableOptionsProp>,
    default: () => ({}),
  },
  list: {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    type: Array as PropType<any[]>,
    required: true,
  },
  itemKey: {
    type: String,
    required: true,
  },
},
  emits: ["start", "end", "add", "remove", "update"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

// defineExpose(['scollVerticalTop'])
const isDragging = ref(false)
const containerRef = ref<HTMLElement | null>(null)
const sortable = ref<Sortable | null>(null)

const scollVerticalTop = (objdata: ElementType) => {
  if (!containerRef.value) return
  let itemHeight = objdata.itemHeight
  let curIndex = objdata.index
  let itemRectY = objdata.itemRectY
  itemHeight += 10
  curIndex += 1
  itemRectY -= 10
  const scrollTop = containerRef.value.scrollTop
  const scrollHeight = containerRef.value.scrollHeight
  const offsetHeight = containerRef.value.offsetHeight
  const currentIndexHeigt = scrollTop + offsetHeight
  const moveTop = itemHeight * 2 
  const h = itemHeight * curIndex 
  if (h > currentIndexHeigt) {
    const needHight = currentIndexHeigt + moveTop
    if (needHight >= scrollHeight) {
      containerRef.value.scrollTop = scrollHeight
    }
    else {
      containerRef.value.scrollTop += moveTop
    }    
    return
  }
  if (itemRectY < 0) {
    if (containerRef.value.scrollTop <= 0) {
      containerRef.value.scrollTop = 0
    }
    else {
      containerRef.value.scrollTop -= itemHeight
    }
  }
  if (curIndex === 1) {
    containerRef.value.scrollTop = 0
  }   
}

watch(containerRef, container => {
  if (container) {
    sortable.value = new Sortable(container, {
      ...props.options,
      onStart: event => {
        isDragging.value = true
        emit('start', event)
      },
      onEnd: event => {
        setTimeout(() => {
          isDragging.value = false
          emit('end', event)
        })
      },
      onAdd: event => emit('add', event),
      onRemove: event => emit('remove', event),
      onUpdate: event => emit('update', event),
    }) 
  }
})

watch(() => props.options, options => {
  if (options && sortable.value) {
    for (const key in options) {
      const name = key as keyof SortableOptionsProp
      const value = options[key as keyof SortableOptionsProp]
      sortable.value.option(name, value)
    }
  }
})

onUnmounted(() => {
  if (sortable.value) {
    sortable.value.destroy()
    containerRef.value = null
    sortable.value = null
  }
})

__expose({
  scollVerticalTop
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "containerRef",
    ref: containerRef,
    class: _normalizeClass(_ctx.$props.class),
    style: {"position":"relative"}
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
      return _renderSlot(_ctx.$slots, "item", {
        key: item[props.itemKey],
        element: item,
        index: index
      })
    }), 128))
  ], 2))
}
}

})